import React from 'react';
import { getTransportIcon } from './transportIcons';

const TransportAccordion = ({ transports, citySlug }) => {
  if (!transports || transports.length === 0) return null;

  return (
    <div
      id={`htr-panel-${citySlug}`}
      role="tabpanel"
      style={{ display: 'flex', flexDirection: 'column', gap: 10 }}
    >
      {transports.map((t, idx) => {
        const Icon = getTransportIcon(t.mode_slug);
        return (
          /* Using <details>/<summary> so content is visible to crawlers without JS */
          <details
            key={t.id}
            open={idx === 0}
            style={{
              backgroundColor: 'white',
              borderRadius: 12,
              border: '1.5px solid #e5e7eb',
              overflow: 'hidden',
            }}
          >
            <summary
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: 12,
                padding: '14px 20px',
                cursor: 'pointer',
                listStyle: 'none',
                fontWeight: 600,
                fontSize: 15,
                color: '#1f2937',
                userSelect: 'none',
              }}
            >
              <span style={{
                width: 36,
                height: 36,
                borderRadius: '50%',
                backgroundColor: '#f0fdf4',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexShrink: 0,
              }}>
                <Icon size={18} color="#16a34a" />
              </span>
              <span style={{ flex: 1 }}>{t.mode}</span>
              {t.duration_text && (
                <span style={{ fontSize: 12, color: '#6b7280', fontWeight: 400 }}>
                  ~{t.duration_text}
                </span>
              )}
            </summary>

            <div style={{ padding: '0 20px 18px 68px', borderTop: '1px solid #f3f4f6' }}>
              <p style={{
                fontSize: 14,
                color: '#4b5563',
                lineHeight: 1.7,
                marginTop: 12,
                whiteSpace: 'pre-line',
              }}>
                {t.description}
              </p>

              {/* Optional metadata pills */}
              {(t.distance_km || t.est_cost_inr) && (
                <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap', marginTop: 12 }}>
                  {t.distance_km && (
                    <span style={pill}>~{t.distance_km} km</span>
                  )}
                  {t.est_cost_inr && (
                    <span style={pill}>{t.est_cost_inr}</span>
                  )}
                </div>
              )}

              {t.maps_link && (
                <a
                  href={t.maps_link}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    display: 'inline-block',
                    marginTop: 12,
                    fontSize: 13,
                    color: '#16a34a',
                    fontWeight: 600,
                    textDecoration: 'none',
                  }}
                >
                  View on Map →
                </a>
              )}
            </div>
          </details>
        );
      })}
    </div>
  );
};

const pill = {
  padding: '3px 12px',
  backgroundColor: '#f3f4f6',
  color: '#374151',
  borderRadius: 20,
  fontSize: 12,
  fontWeight: 500,
};

export default TransportAccordion;
